import React, { useState } from 'react';
import { Box, Typography, Tooltip, ClickAwayListener } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

interface Props {
  children?: React.ReactNode;
  header?: string;
  label?: string;
  required?: boolean;
  description?: string;
  subtype?: string;
}

const subtypeHeaderFontSize: Record<string, number> = {
  h1: 24,
  h2: 23,
  h3: 22,
  h4: 21,
  h5: 20,
  h6: 19,
};

const ContainerComponent: React.FC<Props> = ({ children, header, label, required, description, subtype }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipClose = () => setTooltipOpen(false);
  const handleTooltipOpen = () => setTooltipOpen(true);

  return (
    <Box style={{ background: 'white', borderRadius: 5 }}>
      {header && (
        <Box style={{ padding: '10px 15px', borderRadius: 5 }}>
          <Typography style={{ fontSize: subtype ? subtypeHeaderFontSize[subtype] || 24 : 24, fontWeight: 500 }}>
            {header}
          </Typography>
        </Box>
      )}

      {children && (
        <Box style={{ padding: 24 }}>
          {label && (
            <Box>
              <Typography style={{ fontSize: 16, marginBottom: 15, fontFamily: "'Google Sans',Roboto,Arial,sans-serif" }}>
                {label} {required ? '*' : ''}{' '}
                {description && (
                  <ClickAwayListener onClickAway={handleTooltipClose}>
                    <Tooltip title={description} placement="top" arrow onClose={handleTooltipClose} open={tooltipOpen}>
                      <InfoOutlinedIcon style={{ fontSize: 20, opacity: 0.7, marginBottom: -4 }} onClick={handleTooltipOpen} />
                    </Tooltip>
                  </ClickAwayListener>
                )}
              </Typography>
            </Box>
          )}

          <Box>{children}</Box>
        </Box>
      )}
    </Box>
  );
};

export default ContainerComponent;
